module.exports = __webpack_public_path__ + "static/media/eye.8b13350e.svg";